import script from "./headerBox.vue?vue&type=script&setup=true&lang=js"
export * from "./headerBox.vue?vue&type=script&setup=true&lang=js"

import "./headerBox.vue?vue&type=style&index=0&id=398492a2&lang=scss"

const __exports__ = script;

export default __exports__